import { __require as o } from "./Errors.mjs";
var r, t;
function s() {
  if (t) return r;
  t = 1;
  const s = o().BatchFullError;
  return r = class {
    constructor() {
      this.lookups = [];
    }
    add(o) {
      if (!this.lookupsHasRoomForLookup()) throw new s();
      this.lookups.push(o);
    }
    lookupsHasRoomForLookup() {
      return this.lookups.length < 100;
    }
    length() {
      return this.lookups.length;
    }
    getByIndex(o) {
      return this.lookups[o];
    }
    getByInputId(o) {
      return this.lookups.filter(r => r.inputId === o)[0];
    }
    clear() {
      this.lookups = [];
    }
    isEmpty() {
      return 0 === this.length();
    }
  };
}
export { s as __require };